import { useQuery } from '@tanstack/react-query';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

const fetchCourseOutline = async (courseId) => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/discovery/course-outline/${encodeURIComponent(courseId)}/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

export const useCourseOutline = (courseId) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['courseOutline', courseId],
    queryFn: () => fetchCourseOutline(courseId),
    enabled: Boolean(courseId),
    staleTime: 10 * 60 * 1000,
  });

  return {
    outline: data || null,
    loading: isLoading,
    error,
  };
};
